module.exports = __webpack_public_path__ + "img/mamerbg.c69b96a6.jpg";